import { render, staticRenderFns } from "./PayInvitation.vue?vue&type=template&id=20fc300a&scoped=true"
import script from "./PayInvitation.vue?vue&type=script&lang=ts"
export * from "./PayInvitation.vue?vue&type=script&lang=ts"
import style0 from "./PayInvitation.vue?vue&type=style&index=0&id=20fc300a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc300a",
  null
  
)

export default component.exports